<template>
  <div id="payment-method">
    <v-container style="background:white; padding: 15px; border-bottom: 1px solid lightgray;">
      <div class="image-p">
        <v-layout row wrap>
        <v-flex x12 style="">
          <div style="display:flex;align-items:center;">
            <v-btn small icon dark @click="$router.push('/premium')">
              <v-icon style="color:#10AA85;">arrow_back</v-icon>
            </v-btn>
            <h2 style="color:#10AA85;">Konfirmasi Pembayaran</h2>
          </div>
        </v-flex>
      </v-layout>
      </div>
    </v-container>
    <v-container style="padding:10px;border-bottom: solid 2px #d8d8d8;">
      <v-layout>
        <v-flex xs5 class="tabs-payment">
          <h3 style="color:#d8d8d8;">
            Metode Bayar
          </h3>
        </v-flex>
        <v-flex xs2 class="tabs-payment">
          <img src="@/assets/icon/arrow_right.png" style="width:30px;height:40px;" alt="avatar">
        </v-flex>
        <v-flex xs5 class="tabs-payment">
          <h3 style="color:#10AA85;">
            Bayar
          </h3>
          </v-flex>
      </v-layout>
    </v-container>

    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-expansion-panel focusable expand v-model="panel">
              <v-expansion-panel-content>
                <template v-slot:header>
                    <span style="font-size:20px;"><b>ID-Transaksi:</b> {{ data.code }}</span>
                </template>
                <v-card>
                  <v-card-text>
                    <p style="margin-bottom:5px;"><b style="font-weight:bold;">{{ data.title }}</b></p>
                    <p style="margin-bottom:15px;" v-html="data.description">
                    </p>
                    <v-divider></v-divider>
                    <v-layout row wrap style="margin-top:10px;">
                      <v-flex xs6>Metode Pembayaran</v-flex>
                      <v-flex xs6 style="text-align:right;"><b>{{ data.payment_bank_name }}</b></v-flex>
                      <v-flex xs6 >Harga</v-flex>
                      <v-flex xs6 style="text-align:right;"><b>{{ data.unique_price | currency }}</b></v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card style="margin-top:20px;">
            <v-card-title style="background-color:#f9f9f9">
              <span style="font-size:20px;font-weight:500;">Unggah Bukti Transfer</span>
            </v-card-title>
            <v-card-text>
            <v-container style="padding-top:0;">
              <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        label="Tanggal Transfer"
                        v-model="upld.transfer_datetime"
                        readonly
                        single-line
                        outline
                        required
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="thenPickTime(date)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <v-dialog
                    ref="dialog"
                    v-model="modal2"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <v-time-picker v-model="timePick" format="24hr">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="confirmDate(timePick)">OK</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                      label="Nama Bank"
                      v-model="upld.bank_name"
                      single-line
                      outline
                      required
                      :rules="nameRules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                      label="Nama Pemilik Rekening"
                      single-line
                      v-model="upld.account_name"
                      outline
                      required
                      :rules="nameRules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                      label="Nomor Whatsapp"
                      single-line
                      outline
                      v-model="upld.phone_number"
                      required
                      @keydown="filterKey"
                      :rules="phoneRules"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              </v-form>
              <v-layout row wrap text-xs-center>
                <v-flex xs12>
                  <img v-if="url" :src="url" style="max-width:100%;" ref="file" alt="avatar">
                </v-flex>
                <v-flex xs12>
                  <!-- <p style="color:#2c2c2c;">( format .JPG, .JPEG, .PNG max 5 MB)</p> -->
                  <input id="fileUpload" type="file" hidden @change="onFileChange" :rules="nameRules" accept=".jpg, .jpeg, .png">
                  <v-btn color="#10aa85" block dark round large @click="chooseFiles()">Pilih Gambar</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="margin-top:15px;">
                <v-flex xs12><i>Pastikan bukti pembayaran menampilkan:</i></v-flex>
                <v-flex xs12 id="tnc">
                  <ul>
                    <li>
                      <b>Tanggal/Waktu Transfer</b>
                      <p>contoh: tgl 20/05/20 jam 22:12:05</p>
                    </li>
                    <li>
                      <b>Status Berhasil</b>
                      <p>contoh: Transfer BERHASIL, transaksi SUKSES</p>
                    </li>
                    <li>
                      <b>Detail Penerima</b>
                      <p>contoh: Transfer ke Rek. NF JUARA</p>
                    </li>
                    <li>
                      <b>Jumlah Transfer</b>
                      <p>contoh: Rp 987.654</p>
                    </li>
                  </ul>
                </v-flex>
              </v-layout>
            </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      
      <v-btn style="margin-top:0px;" :disabled="validationCheck() || startProgress" large block round dark color="#10aa85" @click="confirm()">
        {{!startProgress ? 'kIRIM BUKTI TRANSFER' : ''}}

        <v-progress-circular
          v-if="startProgress"
          indeterminate
          color="white"
        ></v-progress-circular>
      </v-btn>
    </v-container>
    <v-dialog persistent v-model="expiredTransaction">
      <v-card style="padding: 15px;border-radius: 12px;">
        <v-layout text-xs-center row wrap>
          <v-flex xs12 style="margin-bottom:15px;">
            <img src="@/assets/icon/ic_popupconfirm_2.svg" alt="image-alt"/>
          </v-flex>
          <v-flex xs12><p>Transaksi ini sudah melewati batas waktu pembayaran. Lakukan transaksi ulang untuk membeli produk ini.</p></v-flex>
          <v-btn round block light @click="expired()">Oke</v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="toastAlert"
      :timeout="3000"
      color="black"
      dark
    >
      Foto bukti transfer wajib disertakan
    </v-snackbar>
    <v-snackbar
      v-model="exceedFileSize"
      :timeout="3000"
      color="black"
      dark
    >
      Gambar melebihi batas ukuran
    </v-snackbar>
    <v-snackbar
      v-model="invalidFileType"
      :timeout="3000"
      color="black"
      dark
    >
      Jenis gambar tidak mendukung
    </v-snackbar>
  </div>
</template>
<style>
#payment-method {
  background-color:white;
}

#acc {
  color:white;
  cursor:context-menu; position:absolute; z-index: -1;
}
#price {
  color:white;
  cursor:context-menu; position:absolute; z-index: -1;
}
.tabs-payment {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.v-expansion-panel__header {
  background-color: #f9f9f9 !important;
}

#tnc ul {
  list-style: none;
}

#tnc ul li::before {
  content: "\2022";
  /* color: #3cb54a; */
  font-weight: bold;
  display: inline-block;
  width: 0.8em;
  margin-left: -1em;

}
.waiting-transaction {
  display:flex;flex-flow:row;align-items:flex-end; background-color:#fcf1b3; padding-bottom:6px;
}
.waiting-transaction-text {
  padding: 5px;padding-top:5px;
}
/* .v-snack.v-snack--active.v-snack--bottom {
  max-width: 270px;
  margin: 0 auto;
  color: white;
  border: lightgray 1px;
  box-shadow: 0px;
  border-radius: 50px;margin-bottom: 15px;
  text-align:center;
} */

.input-date {
  border: 2px solid rgba(0,0,0,0.1);
  width:100%;
  min-height: 56px;
  border-radius: 200px !important;
  padding: 0 12px;
  font-size:16px;
  margin-bottom:30px;
}
.dum-placeholder {
  position: absolute;
  font-size: 17px;
  color: rgba(0,0,0,0.57);
  padding: 17px;
  pointer-events: none;
}
</style>
<script>
import moment, { localeData } from 'moment/src/moment'

export default {
  name: 'payment-method',
  data () {
    return {
      data: JSON.parse(localStorage.getItem('payment_detail')),
      toast: false,
      upld: {
        bank_name: null,
        account_name: null,
        phone_number: null,
        transfer_datetime: ''
      },
      panel: [true],
      url: null,
      toastAlert: false,
      exceedFileSize: false,
      invalidFileType: false,
      file: null,
      valid: true,
      expiredTransaction: false,
      startProgress: false,
      datePick: '',
      timePick: '',
      phoneRules: [
        v => !!v || 'Nomor telepon diisi',
        v => (v && v.length <= 15 || 'Nomor telepon maksimal 15 digit'),
        v => /^[\d ()+-]+$/.test(v) || 'Nomor telepon tidak valid'
      ],
      nameRules: [
        v => !!v || 'Wajib diisi'
        // v => (v && v.length <= 30 || 'Harus kurang dari 30 karakter')
      ],
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      modal2: false
    }
  },
  filters: {
    filterKey (e) {
      const key = e.key
      if (key === '.') { return e.preventDefault() }
      if (key === ',') { return e.preventDefault() }
      if (key === 'e') { return e.preventDefault() }
      if (key === '-') { return e.preventDefault() }
      if (key === '+') { return e.preventDefault() }
    },
    currency (value) {
      let val = (value / 1).toFixed(0).replace('.', ',')
      return 'Rp' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    totalCurrency (value) {
      let val = (value / 1).toFixed(0).replace('.', ',')
      var string = 'Rp' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      var str = string.substring(0, string.length - 3)
      return str
    },
    moment: function (date) {
      var date1 = moment.utc(date).format('dddd, DD MMMM YYYY')
      var date2 = moment.utc(date).format('HH:mm')
      return date1 + ' pukul ' + date2
    },
    accNum (value) {
      if (value) {
        let acc = value.match(/.{1,3}/g)
        return acc.join(' ')
      }
    }
  },
  mounted () {
    let phn = JSON.parse(sessionStorage.getItem('profile'))
    this.upld.phone_number = phn.phone_number
    this.timePick = moment(new Date()).format('HH:mm')
  },
  methods: {
    thenPickTime (date) {
      this.modal = false
      this.modal2 = true
    },
    confirmDate (time) {
      this.modal2 = false
      let a = moment(this.date, 'YYYY-MM-DD').format('DD/MM/YYYY')
      this.upld.transfer_datetime = a + ' ' + time
    },
    filterKey (e) {
      const key = e.key
      if (key === '.') { return e.preventDefault() }
      if (key === ',') { return e.preventDefault() }
      if (key === 'e') { return e.preventDefault() }
      if (key === '-') { return e.preventDefault() }
      if (key === '+') { return e.preventDefault() }
    },
    validationCheck () {
      if (this.url !== null && this.upld.bank_name !== null && this.upld.account_name !== null && this.upld.transfer_datetime !== '') {
        return false
      } else {
        return true
      }
    },
    expired () {
      this.expiredTransaction = false
      this.$router.push('/premium')
    },
    chooseFiles () {
      document.getElementById('fileUpload').click()
    },
    onFileChange (e) {
      const file = e.target.files[0]
      // this.file = e.target.files[0]

      const fileType = file['type']
      const validImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/svg+xml', 'image/gif']
      if (!validImageTypes.includes(fileType)) {
        this.invalidFileType = true
        this.file = null
        this.url = null
      } else {
        let _this = this
        let fileObj = file
        let reader = new FileReader()
        reader.readAsDataURL(fileObj)
        reader.onload = function (e) {
          let image = new Image()
          image.src = e.target.result
          image.onload = function () {
            let canvas = document.createElement('canvas')
            let context = canvas.getContext('2d')
            // console.log(image.width)
            if (parseInt(image.width) >= 1024) {
              let imageWidth = 0
              let imageHeight = 0
              if (parseInt(image.width) >= 4000) {
                imageWidth = image.width / 15
                imageHeight = image.height / 15
              } else if (parseInt(image.width) >= 2000 && parseInt(image.width) < 4000) {
                imageWidth = image.width / 11
                imageHeight = image.height / 11
              } else {
                imageWidth = image.width / 5
                imageHeight = image.height / 5
              }

              let data = ''
              canvas.width = imageWidth
              canvas.height = imageHeight
              context.drawImage(image, 0, 0, imageWidth, imageHeight)
              canvas.toBlob(function (blob) {
                _this.url = URL.createObjectURL(blob)
                _this.file = blob
              }, 'image/png')
            } else {
              _this.url = URL.createObjectURL(fileObj)
              _this.file = fileObj
            }
          }
        }
      }
    },
    confirm () {
      this.startProgress = true
      if (this.url === null) {
        this.toastAlert = true
        return
      }
      if (this.$refs.form.validate()) {
        var datetime = null
        if (this.upld.transfer_datetime === '' || this.upld.transfer_datetime === 'Invalid date') {
          this.upld.transfer_datetime = null
        } else {
          datetime = moment(this.upld.transfer_datetime, 'DD/MM/YYYY HH:mm').format('x')
        }
        var body = {
          bank_name: this.upld.bank_name,
          account_name: this.upld.account_name,
          phone_number: this.upld.phone_number,
          transfer_datetime: datetime
        }
        let formData = new FormData()
        formData.append('file', this.file)
        formData.append('request', JSON.stringify(body))
        this.$store.dispatch('funcUploadReceipt', [formData, this.data.id]).then(response => {
          if (response.data.status === 'CONFIRMED') {
            sessionStorage.setItem('CO-' + sessionStorage.UID + '-' + response.data.id, JSON.stringify(response.data))
            this.$router.push('/payment-status/' + response.data.id + '/c')
          }
          this.startProgress = false
        }).catch(err => {
          if (err.response && err.response.data.message === 'Transaction steps failed, your transaction already EXPIRED') {
            this.expiredTransaction = true
          }
          this.startProgress = false
        })
      }
    }
  }
}
</script>
